/////////////////////////////////////////////////V5CommentStart
// This object covers New Car Deals and Used Car Deals, both are routed here
// 2023-01-28 - removed comments with old window resizing bits
/////////////////////////////////////////////////V5CommentEnd 
import React from 'react'
import { Row, Col, Image, Button } from 'react-bootstrap'
import ScriptTag from 'react-script-tag'
import Sentinel from './Sentinel'

export default class Detroit extends React.PureComponent {
  constructor(props) {
    super(props)
  }
  
render() {

    if (this.props.widget == 'NEWDEAL') 
    {
      var  temp_CLASS = 'dt-new-car-image'
      var    temp_CID = 'CIDNEW'
    }
    else 
    {
      var  temp_CLASS = 'dt-used-car-image'
       var   temp_CID = 'CIDUSED'
    }
    
    
    return (

      <article className="Detroit">
        {/*<Sentinel>*/}
        <ScriptTag
          type="text/javascript"
          src="https://www.rydeshopper.com/app/shoppingtools/scripts/widget-inline.js"
        />
        <Row>
          <Col mdOffset={3} md={6} xs={12}>
          <div class={temp_CLASS} data-gid="0000-2596" data-tenant="CFD2049" data-make="Chevrolet" data-model="Blazer" data-cid={temp_CID}  data-color-primary="#337AB7" data-color-headline="#C32B2B" data-font="Helvetica" data-use-qs></div>
          </Col>
        </Row>
        {/*</Sentinel>    still no idead if i need this!*/}
      </article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Detroit.js